export interface IContactUsFormValue {
  fullName?: string;
  phoneNumber?: string;
  email: string;
  organization?: string;
  role?: string | null;
  industry?: string | null;
  existingClient?: boolean | null;
  message?: string;
  topicsOfInterest?: ETopics[] | string;
  referrer?: EReferrer[] | string;
  newsletterOptIn: boolean;
  contactType: EContactType;
}

export enum EContactType {
  CONTACT_US = 'contact-us',
  DEMO_REQUEST = 'demo-request',
  QUOTE_SAMPLE_PERSONALIZATION = 'quote-sample-personalization',
  NEWSLETTER = 'newsletter',
}

export enum ETopics {
  ACTIVE_MILITARY = 'Active Military',
  VETERANS = 'Veterans',
  SECURITY_PREPAREDNESS = 'Security & Preparedness',
  EDUCATION = 'Education',
  HEALTH_WELLNESS = 'Health & Wellness',
  WORK_LIFE_SAFETY = 'Work Life & Safety',
  OTHER = 'Other',
}

export enum EReferrer {
  WEB_SEARCH = 'Web search',
  SOCIAL_MEDIA = 'Social media',
  REFERRAL = 'Referral',
  QS_PRODUCT = 'A QuickSeries product',
  EMAIL = 'Email',
  OTHER = 'Other',
}
